import { NgModule } from '@angular/core';
import { ArrowNavigationDirective } from './arrow-navigation.directive';

@NgModule({
  declarations: [ArrowNavigationDirective],
  exports: [ArrowNavigationDirective],
})
export class ArrowNavigationModule {}
